import { useMutation, useQueryClient } from "@tanstack/react-query"
import { createProduct } from "@/lib/api/product.api"
import type { ProductFormValues } from "@/lib/schemas/product.schema"
import { useAuthStore } from "@/store/auth.store"

export function useCreateProduct(companyId: string) {
  const accessToken = useAuthStore((s) => s.accessToken)
  const queryClient = useQueryClient()

  return useMutation({
    mutationFn: (values: ProductFormValues) => {
      if (!accessToken) throw new Error("Not authenticated")

      // Strip undefined optional fields
      const payload = Object.fromEntries(
        Object.entries({
          companyId,
          productName: values.productName,
          description: values.description,
          tags: values.tags,
          productCode: values.productCode,
          productCategory: values.productCategory,
          productSubCategory: values.productSubCategory,
        }).filter(([, v]) => v !== undefined)
      )

      return createProduct(payload as unknown as Parameters<typeof createProduct>[0], accessToken)
    },
    onSuccess: () => {
      // Invalidate product list so it re-fetches with the new entry
      queryClient.invalidateQueries({ queryKey: ["company-products", companyId] })
    },
    onError: (error: Error) => {
      console.error("Product creation failed:", error.message)
    },
  })
}
